export default {
  width: 800,
  height: 400,
  config: {
    title: {
      fontSize: 18,
      font: 'Times New Roman',
      anchor: 'center',
      fontColor: '#000000',
    },
    axisX: {
      domain: true,
      domainColor: '#000000',
      grid: false,
      labelFont: 'Times New Roman',
      labelFontSize: 14,
      titleFont: 'Times New Roman',
      titleFontSize: 14,
      titleFontWeight: 'normal',
      title: 'X Axis Title (units)',
    },
    axisY: {
      domain: true,
      grid: false,
      gridColor: '#DEDDDD',
      gridWidth: 1,
      labelFont: 'Times New Roman',
      labelFontSize: 14,
      labelAngle: 0,
      ticks: false,
      titleFont: 'Times New Roman',
      titleFontSize: 14,
      titleFontWeight: 'normal',
      titlePadding: 10,
      title: 'Y Axis Title (units)',
    },
    range: {
      category: [
        '#2980B9',
        '#003366',
        '#FFAE19',
        '#D68910',
        '#E67E22',
        '#D35400',
        '#FF4500',
        '#FF6162',
        '#438B28',
        '#45B39D',
        '#99ADC1',
        '#212F3C',
      ],
    },
    legend: {
      labelFont: 'Times New Roman',
      labelFontSize: 14,
      symbolType: 'square',
      symbolSize: 100,
      titleFont: 'Times New Roman',
      titleFontSize: 14,
      titleFontWeight: 'normal',
      title: 'Legend',
      orient: 'right',
      offset: 0,
    },
    tooltip: { font: 'Open Sans' },
    view: {
      stroke: 'transparent',
      text: {
        font: 'Times New Roman',
        color: [
          '#2980B9',
          '#003366',
          '#FFAE19',
          '#D68910',
          '#E67E22',
          '#D35400',
          '#FF4500',
          '#FF6162',
          '#438B28',
          '#45B39D',
          '#99ADC1',
          '#212F3C',
        ],
        fontSize: 14,
        align: 'right',
        fontWeight: 400,
        size: 14,
      },
      bar: {
        size: 40,
        binSpacing: 1,
        continuousBandSize: 30,
        discreteBandSize: 30,
        fill: [
          '#2980B9',
          '#003366',
          '#FFAE19',
          '#D68910',
          '#E67E22',
          '#D35400',
          '#FF4500',
          '#FF6162',
          '#438B28',
          '#45B39D',
          '#99ADC1',
          '#212F3C',
        ],
        stroke: false,
      },
    },
    font: 'Times New Roman',
  },
  concat: [
    {
      mark: { type: 'rect', color: '#2980B9' },
      encoding: {
        tooltip: [
          { type: 'nominal', field: 'i_5_cost', title: 'Response (Binned)' },
          {
            type: 'quantitative',
            aggregate: 'sum',
            field: 'pct',
            format: '.2%',
            title: 'Percentage',
          },
        ],
        x: {
          type: 'quantitative',
          axis: { title: 'Kenyan Shillings ' },
          bin: { extent: [1, 15000], step: 1000 },
          field: 'i_5_cost',
          scale: { clamp: true, domain: [1, 15000] },
        },
        y: {
          type: 'quantitative',
          aggregate: 'sum',
          axis: { format: '%' },
          field: 'pct',
          title: '',
        },
      },
      height: 500,
      selection: {
        selector026: {
          type: 'single',
          fields: ['elc_aggr_tier'],
          bind: {
            input: 'select',
            options: [
              null,
              'Tier 0',
              'Tier 1',
              'Tier 2',
              'Tier 3',
              'Tier 4',
              'Tier 5',
            ],
            labels: [
              'All Tiers',
              'Tier 0',
              'Tier 1',
              'Tier 2',
              'Tier 3',
              'Tier 4',
              'Tier 5',
            ],
            name: 'Electricity Tier  ',
          },
        },
        selector029: {
          type: 'single',
          fields: ['i_18_b_2nd_fuel'],
          bind: {
            input: 'select',
            options: [
              null,
              'Kerosene',
              'Coal/lignite',
              'Charcoal',
              'Crop Residue/Plant Biomass',
              'Saw Dust',
              'LPG/cooking gas',
            ],
            labels: [
              'All Fuel Types',
              'Kerosene',
              'Coal/lignite',
              'Charcoal',
              'Crop Residue',
              'Saw Dust',
              'LPG/cooking gas',
            ],
            name: 'Secondary Fuel Type  ',
          },
        },
        selector028: {
          type: 'single',
          fields: ['i_18_a_1st_fuel'],
          bind: {
            input: 'select',
            options: [
              null,
              'Kerosene',
              'Coal/lignite',
              'Charcoal',
              'Crop Residue/Plant Biomass',
              'Saw Dust',
              'Biogas',
              'LPG/cooking gas',
              'Electricity',
            ],
            labels: [
              'All Fuel Types',
              'Kerosene',
              'Coal/lignite',
              'Charcoal',
              'Crop Residue',
              'Saw Dust',
              'Biogas',
              'LPG/cooking gas',
              'Electricity',
            ],
            name: 'Primary Fuel Type  ',
          },
        },
      },
      title: {
        text: ['How much did you pay for your cookstove?'],
        color: 'black',
        font: 'Times New Roman',
      },
      transform: [
        { joinaggregate: [{ op: 'count', field: '*', as: 'total' }] },
        { calculate: '1 / datum.total', as: 'pct' },
        { filter: { selection: 'selector026' } },
        { filter: { selection: 'selector029' } },
        { filter: { selection: 'selector028' } },
      ],
      width: 800,
    },
  ],
  data: { name: 'data-0cfc4f360a1bf4327191fa7ce9b5e174' },
  title: {
    text: [
      '',
      '',
      'This chart includes responses from 44.88% of households in the Kenya MTF survey sample (total size = 4,590).',
      'Use the dropdown filters to interact with the data.',
    ],
    anchor: 'start',
    baseline: 'bottom',
    font: 'Times New Roman',
    fontSize: 15,
    fontStyle: 'italic',
    fontWeight: 'normal',
    orient: 'bottom',
  },
  $schema: 'https://vega.github.io/schema/vega-lite/v4.8.1.json',
  datasets: {
    'data-0cfc4f360a1bf4327191fa7ce9b5e174': [
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 320.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 320.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 8700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Peri-urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Peri-urban',
        i_5_cost: 13000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 280.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 2000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 0.0,
        i_18_b_2nd_fuel: 'Animal Waste/Dung',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 280.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 280.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 280.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Peri-urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Other Self-Built Stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 280.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 0.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: null,
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 11000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Peri-urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 2000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 13000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 380.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 2700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 21000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 2000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 10500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 750.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 280.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Peri-urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 280.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 750.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Peri-urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Peri-urban',
        i_5_cost: 4900.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 270.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 280.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Peri-urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 25000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Peri-urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 13000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 9000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 13000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 0.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Saw Dust',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 13000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Peri-urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 2500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 1.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 370.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 7600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 4800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Peri-urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Peri-urban',
        i_5_cost: 5300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Peri-urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 3600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 380.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 560.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 34500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 7700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 1800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 13000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 750.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Peri-urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Peri-urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 480.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Peri-urban',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 580.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 1.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Peri-urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Peri-urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Piped Natural Gas',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 18000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 750.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Peri-urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 13000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 4200.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Peri-urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Peri-urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Peri-urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Peri-urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 2000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 270.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 2500.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 7700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 380.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 1550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 1200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 25000.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'Electricity',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 900.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 30000.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'Electricity',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 11000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Peri-urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Peri-urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 1400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 525.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 45000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Electricity',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 620.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Peri-urban',
        i_5_cost: 30000.0,
        i_18_b_2nd_fuel: 'Electricity',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Peri-urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 2000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Peri-urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 950.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Peri-urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 1400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Peri-urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Peri-urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 580.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 7200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Peri-urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Peri-urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Peri-urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Electricity',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Peri-urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 2650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 900.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Peri-urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Peri-urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 480.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 16000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 6600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Coal/lignite',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 1200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 580.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 4900.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 8500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Peri-urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 4800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Processed biomass (pellets)/ woodchips1',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 30000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 750.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 480.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Crop Residue/Plant Biomass',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 4999.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Crop Residue/Plant Biomass',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 15000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 1200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 9000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Biomass Briquette',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 11000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 15000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3900.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Peri-urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4850.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 750.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 15000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 120.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 850.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 8500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 1300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 1600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 460.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 14000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Ethanol',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 20000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: null,
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 1200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 2000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5208.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 750.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 30000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 15000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 850.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3999.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 50000.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 17000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Crop Residue/Plant Biomass',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 11000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 100.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 2700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Crop Residue/Plant Biomass',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4999.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 52000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 750.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 2000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 280.0,
        i_18_b_2nd_fuel: 'Crop Residue/Plant Biomass',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 850.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 0.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1950.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4880.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 4800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 4800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 850.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 380.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 12500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 25000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 280.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3999.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 320.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 850.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 480.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 1300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 28000.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Biomass Briquette',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Biogas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 15000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 1600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 280.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4999.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Coal/lignite',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 20000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Biomass Briquette',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 430.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 390.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 8500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Saw Dust',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 850.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 750.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 35000.0,
        i_18_b_2nd_fuel: 'Electricity',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 1200.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 950.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4800.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 2250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 2500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 0.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: null,
        i_3_label: 'Other',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 580.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Biogas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Crop Residue/Plant Biomass',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 2000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Electricity',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 32000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 40000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 380.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 14500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 19000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 750.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3750.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 2000.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 750.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 25000.0,
        i_18_b_2nd_fuel: 'Electricity',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 680.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 18000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 25000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 14000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 900.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Coal Briquette',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 15000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 430.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 15000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1050.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 8790.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 59.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 380.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 15000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 15000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 26000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 4200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 0.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: null,
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 18000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 12.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 11000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 44000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Biogas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 380.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 900.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 380.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 320.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 4200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 2800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 880.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 15000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Crop Residue/Plant Biomass',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 35000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 10.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 4200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Electricity',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 570.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Saw Dust',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Peri-urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 2200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 750.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 2000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Peri-urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Peri-urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1050.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 13000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 13000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 33000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Biogas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5400.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 9000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 280.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 15000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 4200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1950.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 5600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 480.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 0.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Biogas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 3800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Crop Residue/Plant Biomass',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 280.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 3800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 11500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 2000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 1800.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Saw Dust',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 2200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 380.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Electricity',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 4800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 30000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 14300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Crop Residue/Plant Biomass',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 2400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 16000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 580.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 15000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 24000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 2000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 35000.0,
        i_18_b_2nd_fuel: 'Electricity',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 11000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 900.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 700.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 1600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 1256.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 1256.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Animal Waste/Dung',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Biogas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 22000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Biogas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 850.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 1200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 260.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 35000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Electricity',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 1200.0,
        i_18_b_2nd_fuel: 'Crop Residue/Plant Biomass',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 9000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Processed biomass (pellets)/ woodchips1',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'Biogas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 0.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'Biogas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 240.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 13000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 30.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 1800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Crop Residue/Plant Biomass',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 9500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 1.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 550.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 13000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1100.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 850.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 850.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Rural',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4999.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 6700.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Rural',
        i_5_cost: 430.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: null,
        locality: null,
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Kerosene',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Kerosene',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 20000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 12500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Peri-urban',
        i_5_cost: 35000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 29000.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 29500.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 29500.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 12000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 1400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 7000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Kerosene',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4900.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Peri-urban',
        i_5_cost: 8500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Kerosene',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Kerosene',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 175.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 28000.0,
        i_18_b_2nd_fuel: 'Electricity',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 10.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 20000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 11000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 35000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 180.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 850.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 7500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Kerosene',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 180.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Rural',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Kerosene',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Garbage/plastic',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 1200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 170.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 150.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 20000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 35000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 0.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: null,
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 1',
        locality: 'Urban',
        i_5_cost: 4300.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 650.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 580.0,
        i_18_b_2nd_fuel: 'Firewood',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 15000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Rural',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 2500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 45000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Rural',
        i_5_cost: 380.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 24000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 380.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Kerosene',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 60000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 2500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 19500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 20000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 950.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 20000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 3800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 380.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 0.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Firewood',
        i_3_label: 'Other',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Garbage/plastic',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 5500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 30000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 8000.0,
        i_18_b_2nd_fuel: 'Kerosene',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Kerosene',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 210.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 210.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 26000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 2500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 600.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 2',
        locality: 'Urban',
        i_5_cost: 450.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6300.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Kerosene',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 5000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 10000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 400.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 14000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 500.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 300.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 800.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 900.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 15000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Biogas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 0',
        locality: 'Urban',
        i_5_cost: 350.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 1000.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 5700.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 200.0,
        i_18_b_2nd_fuel: 'Charcoal',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 6000.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 1500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Kerosene',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 3500.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 5',
        locality: 'Urban',
        i_5_cost: 250.0,
        i_18_b_2nd_fuel: 'Not applicable',
        i_18_a_1st_fuel: 'Charcoal',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 4',
        locality: 'Urban',
        i_5_cost: 4500.0,
        i_18_b_2nd_fuel: null,
        i_18_a_1st_fuel: 'Not applicable',
        i_3_label: 'Manufactured stove',
      },
      {
        elc_aggr_tier: 'Tier 3',
        locality: 'Urban',
        i_5_cost: 4000.0,
        i_18_b_2nd_fuel: 'LPG/cooking gas',
        i_18_a_1st_fuel: 'LPG/cooking gas',
        i_3_label: 'Manufactured stove',
      },
    ],
  },
}
